import { icon } from "../../components/assets/assets";

export const actionFieldIconsList = [
  {
    dataToolTipContent: "Completed Job",
    imgSrc: icon.officeChairIcon,
  },

  {
    dataToolTipContent: "Define Interview",
    imgSrc: icon.accountSettingIcon,
  },
  {
    dataToolTipContent: "Invite Candidates",
    imgSrc: icon.workingOnLaptop,
  },
  {
    dataToolTipContent: "Edit Position",
    imgSrc: icon.editBoxIcon,
  },
  {
    dataToolTipContent: "Delete Position",
    imgSrc: icon.deleteIcon,
  },
  {
    dataToolTipContent: "View More",
    imgSrc: icon.eyeIcon,
    modal: true,
  },
];

export const umActionFieldIconsList = [
  
  {
    dataToolTipContent: "Edit User",
    imgSrc: icon.editBoxIcon,
  },
  {
    dataToolTipContent: "Delete User",
    imgSrc: icon.deleteIcon,
  },
  
];

export const numOfPositions = [
  { optionKey: "Select No. of Positions", optionValue: "" },
  { optionKey: "Option 1", optionValue: "1" },
  { optionKey: "Option 2", optionValue: "2" },
  { optionKey: "Option 3", optionValue: "3" },
];

export const recruiters = [
  { optionKey: "Choose recruiters for this position", optionValue: "" },
  { optionKey: "Mamta Bakshi", optionValue: "Mamta Bakshi" },
  { optionKey: "Gurdeep Hora", optionValue: "2" },
];

export const vacancy_locations = [
  { optionKey: "Select cities where vacancies exist", optionValue: "" },
  { optionKey: "City 1", optionValue: "1" },
  { optionKey: "City 2", optionValue: "2" },
  { optionKey: "City 3", optionValue: "3" },
];

export const selectColumnListCreateNewJobPosition = [
  { optionKey: "Select column", optionValue: "" },
  { optionKey: "Job Name", optionValue: "1" },
  { optionKey: "No. of Positions", optionValue: "2" },
  { optionKey: "Start Date", optionValue: "3" },
  { optionKey: "Closing Target", optionValue: "4" },
  { optionKey: "Recruiter", optionValue: "5" },
  { optionKey: "Interview Rounds", optionValue: "6" },
  { optionKey: "Vacancy Locations", optionValue: "7" },
];

export const sortByOptionListCreateNewJobPosition = [
  { optionKey: "Sort By Option", optionValue: "" },
  { optionKey: "Sort ascending", optionValue: "1" },
  { optionKey: "Sort descending", optionValue: "2" },
  { optionKey: "Sort Recent item", optionValue: "3" },
  { optionKey: "Sort Date range", optionValue: "4" },
  { optionKey: "Domain Skills", optionValue: "5" },
  { optionKey: "Soft Skills", optionValue: "6" },
  { optionKey: "Interviewers", optionValue: "7" },
  { optionKey: "Placement Agency", optionValue: "8" },
  { optionKey: "Campus", optionValue: "9" },
];

export const showRowsArray = [
  { optionKey: 10, optionValue: 10 },
  { optionKey: 50, optionValue: 50 },
  { optionKey: 100, optionValue: 100 },
  { optionKey: 500, optionValue: 500 },
  { optionKey: 2000, optionValue: 2000 },
];

export const selectColumnListProductsTable = [
  { optionKey: "Select column", optionValue: "" },
  { optionKey: "Id", optionValue: "Id" },
  { optionKey: "Title", optionValue: "Title" },
  { optionKey: "Price", optionValue: "Price" },
  { optionKey: "Rating", optionValue: "Rating" },
  { optionKey: "Discount", optionValue: "Discount" },
];
export const sortByOptionProductsTable = [
  { optionKey: "Sort By Option", optionValue: "" },
  { optionKey: "Sort ascending", optionValue: "ascendingOrder" },
  { optionKey: "Sort descending", optionValue: "descendingOrder" },
];
